import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="grid place-items-center h-full p-10 text-center">
      <div>
        <p className="text-3xl font-bold text-ws-ink">404</p>
        <p className="mt-1 text-sm text-ws-ink-3">This page could not be found.</p>
        <Link to="/" className="mt-4 inline-block text-sm text-ws-accent underline">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
